export const text = '#3C3C3B';
export const hover = '#638297';
export const primary= '#978C21';
export const Black = "#3C3C3B";
export const whites = "#FFFFFF";
export const title = `"Avenir", Euclid Square, Arial, Helvetica, freesans, sans-serif `;
export const Transition = "cubic-bezier(0.4, 0, 0, 1)";
export const HoverArrow = 'brightness(0) saturate(100%) invert(50%) sepia(67%) saturate(479%) hue-rotate(17deg) brightness(93%) contrast(87%)';
export const BlueArrow = 'brightness(0) saturate(100%) invert(48%) sepia(11%) saturate(1010%) hue-rotate(161deg) brightness(99%) contrast(86%)';